import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'


import BankRecIndex from '@/views/BankReconciliation/BankRec/index'
import UTPage from '@/views/BankReconciliation/BankRec/component/UTPage'
import BankIndex from '@/views/BankReconciliation/Bank/index'
import UnreconciledPage from '@/views/BankReconciliation/BankRec/component/UnreconciledPage'
import BookUnreconciledPage from '@/views/BankReconciliation/BankRec/component/BookUnreconciledPage'
import OutstandPage from '@/views/BankReconciliation/BankRec/component/OutstandPage'
import FundTransferPage from '@/views/BankReconciliation/BankRec/component/FundTransferPage'
import RecordCreditPage from '@/views/BankReconciliation/BankRec/component/RecordCreditPage'
import RecordDebitPage from '@/views/BankReconciliation/BankRec/component/RecordDebitPage'
const dashboardRouter = [
  {
    path: "/BankReconciliation",
    element: <SandBox />,
    children: [
      {
        path: "BankRec",
        element: docLazyFn(<BankRecIndex />),
      },
         {
              path: "Bank",
              element: docLazyFn(<BankIndex />),
            },
    ],
  },
    {
      path: "/BankReconciliation/BankRec/UTPage",
      element: docLazyFn(<UTPage />),
    },
    {
      path: "/BankReconciliation/BankRec/UnreconciledPage",
      element: docLazyFn(<UnreconciledPage />),
    },
      {
      path: "/BankReconciliation/BankRec/component/BookUnreconciledPage",
      element: docLazyFn(<BookUnreconciledPage />),
    },
     {
      path: "/BankReconciliation/BankRec/component/OutstandPage",
      element: docLazyFn(<OutstandPage />),
    },
      {
      path: "/BankReconciliation/BankRec/component/FundTransferPage",
      element: docLazyFn(<FundTransferPage />),
    }, {
      path: "/BankReconciliation/BankRec/component/RecordCreditPage",
      element: docLazyFn(<RecordCreditPage />),
    },{
      path: "/BankReconciliation/BankRec/component/RecordDebitPage",
      element: docLazyFn(<RecordDebitPage />),
    }
];

export default dashboardRouter;
